<app-lcl-card cardTitle="LABELS.MY_DOCUMENTS" isRowOnMobile="true">
  <ng-container header>
    <div class="d-flex align-items-center">
      <div class="download-all-files" *ngIf="isUploadedAnyFiles" (click)="onDownloadAllFiles()">
        {{ "LABELS.DOWNLOAD_ALL_FILES" | translate }}
      </div>

      <div class="btn-group add-documents d-print-none" dropdown>
        <button id="button-files" dropdownToggle type="button" class="btn btn-link dropdown-toggle">
          <span class="wrapper-icon-add"><i class="fa fa-plus"></i></span>
          <span>{{ "BUTTON.ADD_OTHER_DOCUMENT" | translate }}</span>
          <span class="wrapper-icon-carret"><i class="fa fa-caret-down"></i></span>
        </button>
        <ul id="dropdown-files" class="dropdown-menu" role="menu" *dropdownMenu>
          <li role="menuitem" *ngFor="let doc of availablePluralDocTypes" (click)="onAddOtherDocument(doc)">
            <span class="dropdown-item">
              {{ "LABELS.NEW" | translate }}
              {{ "DOCUMENT_TYPE." + enumDocumentType[doc] | translate }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>
  <ng-container body>
    <div class="position-relative">
      <div class="lcl-document-upload-wrapper">
        <p
          class="documents-hint"
          [innerHTML]="
            'LCL_SHIPMENT.SHIPMENT.DOCUMENTS_HINT_USER' | translate : { cutoffDate: shipment.voyage.warehouseCutoff | customDateByUtc }
          "
        ></p>

        <div class="lcl-document-upload-item" *ngFor="let document of attachedDocuments; let index = index; trackBy: trackByFn">
          <document-upload-desktop
            [id]="'lcl-documents-' + shipment?.id + '-' + index + (document.id ? '-' + document.id : '')"
            [attachmentName]="'DOCUMENT_TYPE.' + enumDocumentType[document.type]"
            [attachmentHint]="'DOCUMENT_TYPE.HINT.' + enumDocumentType[document.type]"
            [attachmentTypeName]="'MENU.LCL' | translate | uppercase"
            [isRequired]="true"
            [isStretched]="true"
            [isStripeLayout]="true"
            [uploadedDocument]="document"
            [canUploadDocuments]="!document.uploadedDate"
            [canRemoveDocuments]="isCanRemove"
            (upload)="uploadDocumentCall(document, $event)"
            (remove)="removeDocument(document.id)"
            (stateUpdate)="onDocumentStateUpdate(document.id, $event)"
          ></document-upload-desktop>
        </div>
      </div>

      <loading-spinner [show]="isLoading"></loading-spinner>
    </div>
  </ng-container>
</app-lcl-card>

<app-lcl-card cardTitle="LABELS.EEZYIMPORT_DOCUMENTS">
  <ng-container body>
    <p class="documents-hint" [innerHTML]="'LCL_SHIPMENT.SHIPMENT.DOCUMENTS_HINT_SUPPORT' | translate"></p>

    <div class="lcl-document-upload-item" *ngFor="let document of attachedSupportDocuments; let index = index; trackBy: trackByFn">
      <document-upload-desktop
        [id]="'lcl-documents-' + shipment?.id + '-' + index + (document.id ? '-' + document.id : '')"
        [attachmentName]="'DOCUMENT_TYPE.' + enumDocumentType[document.type]"
        [attachmentTypeName]="'MENU.LCL' | translate | uppercase"
        [isRequired]="false"
        [isStretched]="true"
        [isStripeLayout]="true"
        [isShowOptionalTag]="false"
        [uploadedDocument]="document"
        [canUploadDocuments]="false"
        [canRemoveDocuments]="false"
      ></document-upload-desktop>
    </div>

    <div class="lcl-document-upload-item" *ngFor="let document of attachedESDocuments; let index = index; trackBy: trackByFn">
      <document-upload-desktop
        [id]="'lcl-documents-' + shipment?.id + '-' + index + (document.id ? '-' + document.id : '')"
        [attachmentName]="'DOCUMENT_TYPE.' + enumDocumentType[document.type]"
        [attachmentTypeName]="'DOCUMENT_TYPE.' + enumDocumentType[document.type]"
        [isRequired]="false"
        [isStretched]="true"
        [isStripeLayout]="true"
        [isShowOptionalTag]="false"
        [uploadedDocument]="document"
        [canUploadDocuments]="false"
        [canRemoveDocuments]="false"
      ></document-upload-desktop>
    </div>
  </ng-container>
</app-lcl-card>

<input class="d-none" type="file" #input [accept]="ALLOWED_FILE_MIMES.join(',')" (change)="handleFiles($event)" />
